import { render, staticRenderFns } from "./BottomContent.vue?vue&type=template&id=591716ca&scoped=true"
import script from "./BottomContent.vue?vue&type=script&lang=js"
export * from "./BottomContent.vue?vue&type=script&lang=js"
import style0 from "./BottomContent.vue?vue&type=style&index=0&id=591716ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591716ca",
  null
  
)

export default component.exports